module.exports = {"editor":{"map":"karta","map_name":"%{name} karta","map_pluralize":"%{smart_count} karta |||| %{smart_count} kartor"}}


//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/locale/sw.json
// module id = 311
// module chunks = 0 1 2